const delimeter = '-'

export class CompositeId {
    readonly groupId: string
    readonly itemId: string
    readonly value: string

    constructor(groupId: string, itemId: string) {
        this.groupId = groupId
        this.itemId = itemId
        this.value = `${groupId}${delimeter}${itemId}`
    }

    static parse(value: string) {
        const parts = value.split(delimeter, 2)
        return new CompositeId(parts[0], parts[1])
    }

    /**
     * Gets the group id from the specified composite id (without unnecessary allocations)
     */
    static getGroupId(value: string | undefined) {
        if (value) {
            const delimIndex = value.indexOf(delimeter)
            return delimIndex > 0 ? value.slice(0, delimIndex) : undefined
        }
    }

    /**
     * Gets a value indicating whether a composite id has the specified group id (without allocating a new string).
     */
    static hasGroupId(value: string | undefined, groupId: string) {
        if (groupId.length < 1)
            throw new Error('GroupId must not be empty')
        if (!value)
            return false

        const delimIndex = value.indexOf(delimeter)
        return delimIndex == groupId.length && value.startsWith(groupId)
    }

    /**
     * Gets a value indicating whether two composite ids have the same group id.
     */
    static hasSameGroupId(value1: string | undefined, value2: string | undefined) {
        const groupId1 = CompositeId.getGroupId(value1)
        return groupId1 ? CompositeId.hasGroupId(value2, groupId1) : false
    }

    static isCompositeId(value: string | undefined) {
        return value && value.indexOf('-') > 1
    }
}

